import axios from 'axios';

import * as urls from 'constants/urls';

export const postProjectListSettings = ({ payload }) => {
    return axios.post(urls.PROJECT_LIST_SETTINGS.stringify(), payload);
};

export const postWorksheetListSettings = ({ payload }) => {
    return axios.post(urls.WORKSHEET_LIST_SETTINGS.stringify(), payload);
};

export const postProjectMassListSettings = ({ payload }) => {
    return axios.post(urls.PROJECT_MASS_LIST_SETTINGS.stringify(), payload);
};

export const postWorksheetMassListSettings = ({ payload }) => {
    return axios.post(urls.WORKSHEET_MASS_LIST_SETTINGS.stringify(), payload);
};

export const getProjectListSettingsHandler = () => axios.get(urls.PROJECT_LIST_SETTINGS.stringify());
export const getWorksheetListSettingsHandler = () => axios.get(urls.WORKSHEET_LIST_SETTINGS.stringify());
export const getProjectMassListSettingsHandler = () => axios.get(urls.PROJECT_MASS_LIST_SETTINGS.stringify());
export const getWorksheetMassListSettingsHandler = () => axios.get(urls.WORKSHEET_MASS_LIST_SETTINGS.stringify());
